import {EmptyState, Spinner} from "@shopify/polaris";

export const EmptyStateWithSpinner = ({
    loading = false,
    content = "There are no results matching your search.",
    heading = null,
    action = null,
}) => <EmptyState
    heading={heading}
    action={action}
>
    { loading && (<Spinner size={"large"} />)}
    { !loading && (content)}
</EmptyState>

export const  numberRound = (num) => {
    return Math.round((num + Number.EPSILON) * 100) / 100;
}
